(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/view-options/keno.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/view-options/keno.js');

'use strict';

svs.numbergames.game.view_options.KENO = {
  multiHuxFluxArray: [1, 5]
};

 })(window);